import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/offline-status/regions")({
  beforeLoad() {
    return { pageName: "All regions" };
  }
});
